<template>
  <div class="List">
    <van-sticky :offset-top="0">
      <van-nav-bar :title="title" left-arrow @click-left="onClickLeft">
      </van-nav-bar>
    </van-sticky>
    <van-form validate-first @submit="onSubmit">
      <van-field
        v-model.trim="formdate.name"
        input-align="right"
        required
        :label="titleName + '名称'"
        maxlength="20"
        :placeholder="`请输入${titleName}名称`"
        :rules="[{ required: true, message: `请输入${titleName}名称` }]"
      />
      <van-field
        :value="formdate.source | enumMessage(AllEnums.CRM_CUSTOMER_SOURCE)"
        input-align="right"
        readonly
        label="客户来源"
        placeholder="请选择客户来源"
        @click="openPicker('source')"
      />
      <van-field
        type="number"
        v-model="formdate.mobile"
        input-align="right"
        label="手机号"
        maxlength="11"
        placeholder="请输入手机号"
        :rules="mobileRules(formdate.mobile)"
      />
      <van-field
        type="number"
        v-model="formdate.telephone"
        input-align="right"
        label="电话"
        maxlength="11"
        placeholder="请输入电话"
        :rules="mobileRules(formdate.telephone)"
      />
      <van-field
        :value="
          formdate.industryId | enumMessage(AllEnums.CRM_CUSTOMER_INDUSTRY)
        "
        input-align="right"
        readonly
        label="客户行业"
        placeholder="请选择客户行业"
        @click="openPicker('industryId')"
      />
      <van-field
        :value="formdate.level | enumMessage(AllEnums.CRM_CUSTOMER_LEVEL)"
        input-align="right"
        readonly
        label="客户级别"
        placeholder="请选择客户级别"
        @click="openPicker('level')"
      />
      <van-field
        v-model="formdate.areaName"
        input-align="right"
        readonly
        label="客户地址"
        placeholder="请选择城市"
        @click="openPicker('area')"
      />
      <van-field
        v-model="formdate.detailAddress"
        input-align="right"
        rows="2"
        type="textarea"
        autosize
        maxlength="100"
        label="详细地址"
        placeholder="请输入"
        show-word-limit
      />
      <van-field
        v-model="formdate.remark"
        input-align="right"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="250"
        placeholder="请输入备注"
        show-word-limit
      />
      <div class="bottom-btn">
        <div class="btns">
          <van-button round block type="info" native-type="submit"
            >保存</van-button
          >
        </div>
      </div>
    </van-form>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        v-if="['source'].includes(actionType)"
        show-toolbar
        :columns="AllEnums.CRM_CUSTOMER_SOURCE"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
      <van-picker
        v-if="['industryId'].includes(actionType)"
        show-toolbar
        :columns="AllEnums.CRM_CUSTOMER_INDUSTRY"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
      <van-picker
        v-if="['level'].includes(actionType)"
        show-toolbar
        :columns="AllEnums.CRM_CUSTOMER_LEVEL"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
      <van-picker
        v-if="['area'].includes(actionType)"
        show-toolbar
        :columns="areaList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import Api from "@/api/user";
import { Form, Field, Toast, NoticeBar, sticky } from "vant";
import { idCodeReg } from "@/plugins/common";
Vue.use(Form, Field, NoticeBar);
Vue.use(sticky);
export default {
  data() {
    return {
      idCodeReg,
      formdate: {
        name: "",
        certNo: "",
        telephone: "",
        mobile: "",
        source: "",
        remark: "",
        areaId: "",
        detailAddress: "",
      },
      showPicker: false,
      actionType: "",
      areaList: [],
    };
  },
  computed: {
    phoneRules() {
      if (this.formdate.telephone) {
        return [
          { required: true, message: "请输入电话" },
          {
            pattern: /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$/,
            message: "电话号码格式错误！",
          },
        ];
      } else {
        return [{ required: false, message: "" }];
      }
    },
    isUser() {
      return this.$route.query.type == "user";
    },
    title() {
      let { id } = this.$route.query;
      let t = id ? "编辑" : "新增";
      let n = this.isUser ? "客户" : "线索";
      return t + n;
    },
    titleName() {
      return this.isUser ? "客户" : "线索";
    },
    id() {
      return this.$route.query.id;
    },
  },
  async mounted() {
    let { data: areaList } = await Api.areaList();
    this.areaList = this.setAreaListName(areaList);
    if (this.id) {
      this.loadDetail();
    }
  },
  methods: {
    mobileRules(value) {
      if (value) {
        return [
          { required: true, message: "请输入手机号" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式错误！" },
        ];
      } else {
        return [{ required: false, message: "" }];
      }
    },
    // 递归将areaList内的name改成text,最后返回areaList
    setAreaListName(arr) {
      return arr.map((item) => {
        item.text = item.name;
        if (item.children && item.children.length > 0) {
          this.setAreaListName(item.children);
        } else {
          delete item.children;
        }
        return item;
      });
    },
    async onSubmit() {
      await this.operatorRegister();
    },
    // 新增线索/更新线索
    async operatorRegister() {
      if (this.sbumiting) return;
      try {
        this.sbumiting = true;
        await Api.operatorRegister({
          ...this.formdate,
          isUser: this.isUser,
          ownerUserId: this.userBaseInfo.userId,
        });
        Toast.success({
          message: "提交成功",
        });
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      } catch (error) {
        Toast.fail(error);
      } finally {
        this.sbumiting = false;
      }
    },
    openPicker(actionType) {
      this.actionType = actionType;
      this.showPicker = true;
    },
    onConfirm(value, index) {
      this.formdate[this.actionType] = value;
      switch (this.actionType) {
        case "source":
        case "level":
        case "industryId":
          this.formdate[this.actionType] = value.value;
          break;
        case "area":
          this.formdate.areaId = this.getAreaIdByIndex(index).pop();
          this.$set(this.formdate, "areaName", value.join(" "));
          break;
        default:
          break;
      }
      this.showPicker = false;
    },
    getAreaIdByIndex(index) {
      let city = this.areaList[index[0]];
      let area = city.children[index[1]];
      let street = area.children[index[2]];
      return [city.id, area.id, street.id];
    },

    // 加载详情
    async loadDetail() {
      const loading = Toast.loading();
      try {
        const res = await Api.findDetailById({
          id: this.id,
          isUser: this.isUser,
        });
        this.formdate = res.data;
        loading.close();
      } catch (error) {
        Toast.fail(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.List {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
/deep/.van-uploader__upload {
  background: #efefef;
}
</style>
